import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Grade() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [grades, setGrades] = useState({});

  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/grades/${memberId}`
        );
        setGrades(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchGrades();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">Grade Details</h1>
        <Link to={'/edit-grade/' + memberId}>
          <button className="memberAddButton">Edit</button>
        </Link>
      </div>
      <h3 className="box-title">Grade Name</h3>
      <hr />
      <div className="memberContainer">
        <div className="memberShow">
          <div className="memberShowBottom">
            <div className="memberShowInfo">
              <span className="memberShowInfoLabel">Name:</span>{' '}
              <span className="memberShowInfoTitle">{grades.grade}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
